export const SELECT_SELLITEMS = 'SELECT_SELLITEMS';
export const RESET_SELLITEMS = 'RESET_SELLITEMS';
